import request from '@/CommonDP/utils/request';
// CAD字体维护
export default {
  // 列表
  selectStandardCADFontMaintenance(enterpriseId) {
    return request.get(
      `/cadFontMaintenance/selectStandardFontMaintenance?enterpriseId=${enterpriseId}`
    );
  },
  // 修改
  updateStandardCADFont(params) {
    return request
      .post(`/cadFontMaintenance/updateStandardFont`, params)
      .then((res) => res);
  },
  // 删除
  deleteStandardCADFont(params) {
    return request.get(
      '/cadFontMaintenance/deleteStandardFont',
      {
        params
      }
    );
  },
  // 上传
  uploadStandardCADFontFile(data) {
    return request.post(
      '/cadFontMaintenance/uploadStandardFontFile',
      data,
      { timeout: 0 }
    );
  },
  // 下载
  downloadStandardCADFontFile(fileID) {
    return request({
      url: `/cadFontMaintenance/downloadStandardFontFile/download/${fileID}`,
      method: 'get',
      responseType: 'blob'
    });
  }
};
